import BreadcrumbContainer from "../../components/bonusUi/breadcrumb";

const Breadcrumb = () => {
  return <BreadcrumbContainer />;
};

export default Breadcrumb;
